/**
 * author: Patrick Vyn Badiang
 */
import { Box, CircularProgress, IconButton } from "@mui/material";
import "./EventsPage.css";
import EventCard from "../../components/EventCard";
import { useEffect, useState } from "react";
import 'animate.css';

//import right arrow icon
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

//import left arrow icon
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';


function EventRow() {
  const [currentIndex, setCurrentIndex] = useState(0); // Index of the current event
  const [animationClass, setAnimationClass] = useState(""); // State to manage animation class
  const [EventsData, setEventsData] = useState([]); // State for the fetched events data

  // Handler for navigating to the previous event
  const handlePrevious = () => {
    if (currentIndex > 0) {
      setAnimationClass("animate__fadeInLeft");
      setCurrentIndex(currentIndex - 1);
    }
  };

  // Handler for navigating to the next event
  const handleNext = () => {
    if (currentIndex < EventsData.length - 1) {
      setAnimationClass("animate__fadeInRight");
      setCurrentIndex(currentIndex + 1);
    }
  };

  useEffect(() => {
    fetch('https://9v3dtgzcma.execute-api.us-east-1.amazonaws.com/ascend-events')
      .then(response => response.json())
      .then(data => {
        // Sort by date (assuming format is MM/DD/YYYY)
        const sorted = data.sort((a, b) => {
          const [aMonth, aDay, aYear] = a.date.split('/').map(Number);
          const [bMonth, bDay, bYear] = b.date.split('/').map(Number);
  
          const dateA = new Date(aYear, aMonth - 1, aDay);
          const dateB = new Date(bYear, bMonth - 1, bDay);
  
          return dateA - dateB; // ascending order
        });
  
        setEventsData(sorted);
        setCurrentIndex(0);
      })
      .catch(error => console.log(error));
  }, []);

  // Get the current event based on index
  const currentEvent = EventsData[currentIndex];
  // console.log(currentEvent);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >


{/* Previous Icon */}
<Box className="centered-box">
        {currentIndex > 0 && (
          <IconButton color="primary" sx={{ml:"10px", fontSize:"60px"}} onClick={handlePrevious}>
            <ArrowLeftIcon fontSize="60px" />

          </IconButton>
        )}
      </Box>
      
      

      {/* Event Card with animation class */}
      <div
        className={`animate__animated ${animationClass}`}
        onAnimationEnd={() => setAnimationClass("")} // Reset animation class after animation completes
      >
        {currentEvent ? (
          <EventCard
            name={currentEvent.name}
            date={currentEvent.date}
            description={currentEvent.description}
            eventurl={currentEvent.eventURL}
          />
        ) : (
          <>
    <Box
      border={3}
      borderRadius={10}
      borderColor="primary.main"
      sx={{ width: "100%", minWidth: "400px",maxWidth: "500px", height: "480px", overflow: "hidden" }}
    >
      {/* Placeholder content for empty event */}
      <Box sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <CircularProgress/>
    </Box>
    </Box>
          </>
        )}
      </div>

      

      

      {/* Next Icon */}
      <Box className="centered-box">
        {currentIndex < EventsData.length - 1 && (
          <IconButton color="primary"  onClick={handleNext} sx={{ ml: "5px", fontSize: "60px" }}>
                      
                      <ArrowRightIcon fontSize="80px" />

          </IconButton>
        )}
      </Box>
    </div>
  );
}

export default EventRow;
